module.exports = __webpack_public_path__ + "static/img/home-banner.3ca710a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sustainable/home-banner.png
// module id = +7rm
// module chunks = 2